import { render, staticRenderFns } from "./go-button.vue?vue&type=template&id=50419ad6&scoped=true&"
import script from "./go-button.vue?vue&type=script&lang=js&"
export * from "./go-button.vue?vue&type=script&lang=js&"
import style0 from "./go-button.vue?vue&type=style&index=0&id=50419ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50419ad6",
  null
  
)

export default component.exports